<template>
  <div class="switchers-wrapper">
    <div class="row" v-if="columns">
      <div class="row mb-3 ml-2">
        <b-form-checkbox switch v-model="selectAll" size="lg">
          <span class="h6">{{ $t('common.selectAll') }}</span>
        </b-form-checkbox>
      </div>
      <b-form-group>
        <b-form-checkbox-group v-model="selected" size="lg" switches>
          <b-form-checkbox
            class="col-5 mb-3 ml-2"
            v-for="(col, colName, i) in columns"
            :value="colName"
            :key="i"
          >
            <span class="h6">{{ colName == 'VaccineDocument' ? $t("common.vaccPcr") : $t(`columnSwitcher.${colName.charAt(0).toLowerCase() + colName.slice(1)}`) }}</span>
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
    </div>
    <!-- submit -->
    <div class="d-flex justify-content-end border-top px-3 pt-3">
      <div class="btn-wrapper d-flex align-items-center">
        <b-button
          class="mx-2"
          variant="outline-secondary"
          @click.stop="closeModal"
          >{{ $t('common.cancel') }}</b-button
        >
        <b-button
          class="submit-btn px-4"
          variant="primary"
          @click="onUpdateTableHeaders"
          >{{ $t('common.confirm') }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ColumnsSwitcher",
  props: ["tableHeaders", "url", "modalID", "fetchTableHeaders", "hasDocuments", "grid", "vaccineColumn"],
  data() {
    return {
      selectAll: false,
      selected: [],
      columns: null,
      updatedHeaders: {},
    };
  },
  computed: {
    ...mapGetters("grid", ["getTableHeaders"]),
    getHeadersLength() {
      return Object.keys(this.getTableHeaders).length == this.selected.length;
    },
  },
  watch: {
    selected(headers) {
      Object.keys(this.getTableHeaders).length == headers.length &&
        (this.selectAll = true);
      for (let prop in this.columns) {
        {
          this.updatedHeaders[prop] =
            headers.length > 0 && headers.includes(prop) ? true : false;
        }
      }
    },
    selectAll(value) {
      value
        ? (this.selected = Object.keys(this.columns))
        : (this.selected = []);
    },

    columns(columns){
      const {hasDocuments,grid,vaccineColumn} = this;
      if((hasDocuments && hasDocuments.length == 0) && (grid && grid == 'users' && (vaccineColumn&&!vaccineColumn.userDocument) )){
        delete columns.VaccineDocument 
      }
      if((grid && grid == 'history' || grid && grid == 'dashboard') && (vaccineColumn&&!vaccineColumn.scanDocument) ){
        delete columns.VaccineDocument 
      }
    }
  },
  methods: {
    ...mapActions("grid", ["updateTableHeaders"]),
    getColName(colName) {
      const result = colName.replace(/([A-Z])/g, " $1");
      const title = result.charAt(0).toUpperCase() + result.slice(1);
      return title;
    },
    updateSwitcherValues() {
      for (let prop in this.columns) {
        this.columns[prop] && this.selected.push(prop);
      }
      return this.selected;
    },
    closeModal() {
      this.$bvModal.hide(this.modalID);
    },
    onUpdateTableHeaders() {
      this.updateTableHeaders({
        url: this.url,
        headers: this.updatedHeaders,
      });
      this.$bvModal.hide(this.modalID);
    },
  },
  mounted() {
    this.columns = this.getTableHeaders;
    console.log("this.columns", this.columns);
    this.updateSwitcherValues();
  },
};
</script>
<style lang="scss" >

div#privacyManager{
  div#privacyManager___BV_modal_content_{
    div#privacyManager___BV_modal_body_{
      .col-5.mb-3.custom-control.custom-control-inline.custom-switch.b-custom-control-lg{
  padding-inline-end: 0px!important;
  padding-inline-start: 0px!important;
}
// .form-group{
//   margin-inline-start: 45px;
// }

    }
  }
}

:dir(rtl) .modal-header .close {
  margin-right: auto;
  margin-left: -1rem;
}


</style>